<script setup lang="ts">
import Overlay from '../../Overlay/Overlay.vue'

/*
 * Container query units are used here
 * to demonstrate the usage of `container-type`
 * and to show how it can be used to set the font size
 * based on the container size.
 *
 * more: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_containment/Container_queries
 */
</script>

<template>
  <Overlay
    :class="$attrs.class"
    :style="{ containerType: 'size' }"
    :modelValue="true"
    centered
  >
    <div
      class="font-bold"
      :style="{ fontSize: '5cqw' }"
    >
      <slot />
    </div>
  </Overlay>
</template>
